import { useQuery } from '@tanstack/react-query';
import { getTRSNode } from 'API/TRSNodes/getTRSNode';

const useGetTRSNode = (nodeId, enabled = true) => {
    return useQuery({
        queryKey: ['TRSNode', nodeId],
        queryFn: async () => {
            try {
                const response = await getTRSNode(nodeId);
                return response.data;
            } catch (error) {
                console.error('Error fetching TRS node:', error);
                throw error;
            }
        },
        enabled: enabled && !!nodeId,
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 2,
        refetchOnWindowFocus: false,
    });
};

export default useGetTRSNode;
